import { post } from '@/redux/requests/api.js';
import attachThreadMutationStatus from '@/redux/requests/threads/lib/attachThreadMutationStatus.js';

const markThreadOpened = ({ threadId, openedAt = undefined, authToken = undefined, signal = undefined } = {}) => {
  const normalizedThreadId = String(threadId || '').trim();

  if (!normalizedThreadId) {
    return {
      success: false,
      message: 'threadId is required',
      status: null
    };
  }

  return post(`/v1/pieve/threads/${encodeURIComponent(normalizedThreadId)}/open`, {
    authToken,
    signal,
    data: {
      ...(openedAt ? { openedAt } : {})
    },
    onResponse: attachThreadMutationStatus
  });
};

export default markThreadOpened;
